
<div style="border: 2px solid #c6c6c7;">
  <input type="text" [(ngModel)]="Filter_title" class="form-control"  placeholder="برای جستجوی اینجا تایپ کنید ...">
  <ul style="max-height: 150px;min-height: 150px;overflow-y: scroll;display: block;">
    <li (click)="Change_Item_Status(item)" style="list-style: none;" *ngFor="let item of DataList_ExpertCalibration |filter:Filter_title:'familly'">
      <input type="checkbox" [checked]="item.del" > {{item.name}} {{item.familly}}
    </li>
  </ul>
</div>